import API from "./axios";

export class CategoryService {
    categories(brand: number): Promise<any> {
        return API.post(`api/index.php`, { action: 'getBrandMainCategories', src: 'dashboard', brandid: brand, retrievalmode: 'mysql' });
    }

    subCategories(brand: number, cat: number): Promise<any> {
        return API.post(`api/index.php`, { action: 'getBrandSubCategories', src: 'dashboard', brandid: brand, 'categoryid': cat, retrievalmode: 'mysql' });
    }

    createCategory( data: any): Promise<any> {
      
        return API.post(`api/index.php`, { 'action': 'MainCategoryDataAction', 'src': 'dashboard', retrievalmode: 'mysql',  'data': [data] });
    }

    createSubCategory( data: any): Promise<any> {
      
        return API.post(`api/index.php`, { 'action': 'SubCategoryDataAction', 'src': 'dashboard', retrievalmode: 'mysql',  'data': [data] });
    }

}